import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.SampleHistory`]: `Sample History`,
      [`${prefix}.Preparation.AdditionalVisualDescriptionRequired`]: `Additional Visual Description Required`,
      [`${prefix}.Preparation.VisualDescription`]: `Visual Description`,
      [`${prefix}.Preparation.LargeSieve`]: `4.75mm Sieve`,
      [`${prefix}.Preparation.SmallSieve`]: `2.36mm Sieve`,
      [`${prefix}.Preparation.Thermometer`]: `Thermometer`,
      [`${prefix}.Preparation.Balance`]: `Balance`,
      [`${prefix}.Preparation.TimingMethod`]: `Timing By`,
      [`${prefix}.Preparation.Timer`]: `Timer`,
      [`${prefix}.Preparation.WaterUsed`]: `Water Used`,

      [`${prefix}.MeasurementsAndObservations.TimerWhenCrumbsWerePlaced`]: `Timer Reading When Crumbs Placed (hh:mm:ss)`,
      [`${prefix}.MeasurementsAndObservations.TimeCrumbsWerePlaced`]: `Time Crumbs Were Placed`,
      [`${prefix}.MeasurementsAndObservations.InitialObservationDue`]: `Initial Observation Due (10 minutes)`,
      [`${prefix}.MeasurementsAndObservations.SecondObservationDue`]: `Second Observation Due (2 hours)`,
      [`${prefix}.MeasurementsAndObservations.Slaking`]: `Slaking Occurred`,
      [`${prefix}.MeasurementsAndObservations.Swelling`]: `Swelling`,
      [`${prefix}.MeasurementsAndObservations.DispersionAmount`]: `Amount of Dispersion`,
      [`${prefix}.MeasurementsAndObservations.MicroSieve`]: `425 µm Sieve`,
      [`${prefix}.MeasurementsAndObservations.DispersionOccurred`]: `Dispersion occurred`,
      [`${prefix}.MeasurementsAndObservations.DispersionRemould`]: `Re-moulded Dispersion`,
      [`${prefix}.MeasurementsAndObservations.Calcite`]: `Calcite`,
      [`${prefix}.MeasurementsAndObservations.Gypsum`]: `Gypsum`,
      [`${prefix}.MeasurementsAndObservations.After10Min`]: `After Resting For 10 Minutes`,
      [`${prefix}.MeasurementsAndObservations.WaterTemperature`]: `Water Temperature`,

      [`${prefix}.Results.EmersonClassNumber`]: `Emerson Class Number`,
      [`${prefix}.Results.SoilDescription`]: `Soil Description`,
      [`${prefix}.Results.WaterUsedFlag`]: `Water used`,
      [`${prefix}.Results.WaterUsedResults`]: `Water Used`,
      [`${prefix}.Results.WaterTemperatureFlag`]: `Water temperature`,
      [`${prefix}.Results.WaterTemperatureResults`]: `Water Temperature`,
    }),
    convertLabelUomMapToConfig({})
  );

export default getLabelConfig;
